import api from './api';

export interface SkillSet {
  id: number;
  title: string;
  description: string;
  level: string;
  color: string;
  skills: number[];
  skills_details: Array<{ id: number; name: string; container: number | null }>;
  skills_count: number;
  created_by: number;
  created_at: string;
  updated_at: string;
  order: number;
}

class SkillSetService {
  async getAll(): Promise<SkillSet[]> {
    const response = await api.get('/skill-sets/');
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async get(id: number): Promise<SkillSet> {
    const response = await api.get(`/skill-sets/${id}/`);
    return response.data;
  }

  async create(data: Partial<SkillSet>): Promise<SkillSet> {
    const response = await api.post('/skill-sets/', data);
    return response.data;
  }

  async update(id: number, data: Partial<SkillSet>): Promise<SkillSet> {
    const response = await api.patch(`/skill-sets/${id}/`, data);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/skill-sets/${id}/`);
  }

  async duplicate(id: number): Promise<SkillSet> {
    const response = await api.post(`/skill-sets/${id}/duplicate/`);
    return response.data;
  }

  async reorder(items: { id: number; order: number }[]): Promise<void> {
    await api.post('/skill-sets/reorder/', { items });
  }
}

const skillSetService = new SkillSetService();
export default skillSetService;
